import React from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { DayforceWebhookDetailProvider } from './context/DayforceWebhookDetailProvider'
import { DayforceWebhookDetailMain } from './components/DayforceWebhookDetailMain'
import * as ROUTES from 'constants/routes'
import { DayforceAgenciesProvider } from '../shared/context/DayforceAgenciesProvider'

export const DayforceWebhookDetail = () => {
  const { webhookId } = useParams<{ webhookId: string }>()
  const id = Number(webhookId)

  if (!webhookId || !Number.isFinite(id) || id <= 0) {
    return <Navigate to={ROUTES.DAYFORCE_WEBHOOKS} replace />
  }

  return (
    <DayforceAgenciesProvider>
      <DayforceWebhookDetailProvider webhookId={id}>
        <DayforceWebhookDetailMain />
      </DayforceWebhookDetailProvider>
    </DayforceAgenciesProvider>
  )
}
